export const API_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://novo-dexa.appteste.info' : 'http://localhost:8080'